export const abbrs: any = {
  // Sectors
  "Information Technology": "IT",
  "Telecommunication Services": "Telecom Services",
};
